"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var SimpleGlobal = (function () {
    function SimpleGlobal() {
    }
    return SimpleGlobal;
}());
SimpleGlobal = __decorate([
    core_1.Injectable()
], SimpleGlobal);
exports.SimpleGlobal = SimpleGlobal;
//# sourceMappingURL=simple-global.js.map


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/ng2-simple-global/lib/simple-global.js
// module id = ../../../../ng2-simple-global/lib/simple-global.js
// module chunks = 3